/**
 * Throttle
 *
 * Throttle calls to "callback" routine and ensure that it is not invoked any more often than "delay" milliseconds.
 *
 * @param delay
 * @param callback
 * @returns {Function}
 */
function throttle(delay, callback) {
    let previousCall = new Date().getTime();
    return function () {
        let time = new Date().getTime();
        //
        // if "delay" milliseconds have expired since
        // the previous call then propagate this call to
        // "callback"
        //
        if ((time - previousCall) >= delay) {
            previousCall = time;
            callback.apply(null, arguments);
        }
    };
}

export default throttle;